"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOsUpdateHelper = void 0;
const device_actions_service_1 = require("../device-actions-service");
const OS_UPDATE_ACTION_NAME = 'resinhup';
const getOsUpdateHelper = function (deviceUrlsBase, request) {
    const deviceActionsService = new device_actions_service_1.DeviceActionsService(deviceUrlsBase, request);
    const startOsUpdate = (uuid, targetOsVersion) => {
        return deviceActionsService.startAction({
            uuid,
            actionName: OS_UPDATE_ACTION_NAME,
            params: {
                target_version: targetOsVersion,
            },
        });
    };
    const getOsUpdateStatus = (uuid) => {
        return deviceActionsService.getActionStatus({
            uuid,
            // TODO: this is an assumption recorded here: https://github.com/resin-io/resin-proxy/issues/51#issuecomment-274087973
            actionId: OS_UPDATE_ACTION_NAME,
        });
    };
    return {
        startOsUpdate,
        getOsUpdateStatus,
    };
};
exports.getOsUpdateHelper = getOsUpdateHelper;
